import React from 'react';
import { Modal } from 'semantic-ui-react';
import SaveButton from './SaveButton';
import CloseButton from './CloseButton';

const DualActions = ({
  onClose,
  onSavePrimary,
  onSaveSecondary,
  primaryDataEntryMet,
  primarySaveMessageId = 'actions.save',
  savingPrimary,
  savingSecondary,
  secondaryDataEntryMet,
  secondarySaveMessageId = 'actions.save',
}) => (
  <Modal.Actions>
    <CloseButton onClick={onClose} disabled={savingPrimary} />
    <SaveButton
      secondary
      onClick={onSaveSecondary}
      inProgress={savingSecondary}
      minimumDataEntryMet={secondaryDataEntryMet}
      messageId={secondarySaveMessageId}
      disabled={savingPrimary}
    />
    <SaveButton
      onClick={onSavePrimary}
      inProgress={savingPrimary}
      minimumDataEntryMet={primaryDataEntryMet}
      messageId={primarySaveMessageId}
      disabled={savingSecondary}
    />
  </Modal.Actions>
);

export default DualActions;
